<template>
  <div class="card">
    <h2 class="heading">
      {{ heading }} <span>{{ subheading }}</span>
    </h2>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "PrincipesCardLayout",
  props: {
    heading: String,
    subheading: String
  }
};
</script>

<style lang="sass" scoped>
@import "src/assets/style/vars"

.card
  display: flex
  flex-direction: column
  width: 100%

.heading
  color: $darkColor
  span
    color: $grey
  @media (max-width: 600px)
    span
      display: block

.content
  margin-top: 93px
  @media (max-width: 600px)
    margin-top: 45px
</style>
